// components/projectPage/ProjectActionsMenu.jsx
import React, { Component } from "react";
import { getAuthHeaders, urlMap } from "../../../utils";
import { withRouter } from "../../navigation/withNavigation";
import ActionKebabMenu from "../../components/ActionKebabMenu";
import Modal from "../../components/Modal";

class ProjectActionsMenu extends Component {
  state = { loading: false, showDeleteModal: false };

  updateArchiveStatus = async (archived) => {
    const { project, onUpdated, onCountsChanged, navigate } = this.props;
    if (!project) return;

    if (
      archived &&
      !window.confirm(`Archive “${project.title}”? You can restore it later.`)
    ) {
      return;
    }

    this.setState({ loading: true });
    try {
      const headers = { "Content-Type": "application/json", ...getAuthHeaders() };
      const res = await fetch(`${urlMap.projectEndpoint}/${project.id}`, {
        method: "PUT",
        headers,
        credentials: "include",
        body: JSON.stringify({ archived }),
      });

      if (!res.ok) {
        if (res.status === 409) throw new Error("TITLE_CONFLICT");
        throw new Error(`HTTP ${res.status}`);
      }

      const updated = await res.json();
      onUpdated?.(updated);
      onCountsChanged?.();

      if (archived) navigate?.("/home");
    } catch (e) {
      const msg =
        e?.message === "TITLE_CONFLICT"
          ? "A project with this title is already active. Rename it first, then restore."
          : `Failed to ${archived ? "archive" : "restore"} project.`;
      alert(msg);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleArchive = () => this.updateArchiveStatus(true);
  handleRestore = () => this.updateArchiveStatus(false);

  handleDelete = () => {
    const { project } = this.props;
    if (!project) return;
    this.setState({ showDeleteModal: true });
  };

  confirmDelete = async () => {
    const { project, onCountsChanged, navigate } = this.props;
    this.setState({ showDeleteModal: false, loading: true });
    try {
      const headers = { ...getAuthHeaders() };
      const res = await fetch(`${urlMap.projectEndpoint}/${project.id}`, {
        method: "DELETE",
        headers,
        credentials: "include",
      });
      if (res.status === 204) {
        onCountsChanged?.();
        navigate?.("/home");
        return;
      }
      if (res.status === 404) throw new Error("NOT_FOUND");
      throw new Error(`HTTP ${res.status}`);
    } catch (e) {
      alert("Failed to delete project.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { project, showHint } = this.props;
    const { loading, showDeleteModal } = this.state;
    if (!project) return null;

    const items = !project.archived_at
      ? [
          { key: "archive", label: "🗄 Archive", onClick: this.handleArchive },
        ]
      : [
          { key: "restore", label: "🔄 Restore", onClick: this.handleRestore },
          { key: "delete", label: "🗑 Delete", danger: true, onClick: this.handleDelete },
        ];

    return (
      <>
        <ActionKebabMenu
          placement="inline"
          items={items}
          triggerLabel="Project actions"
          buttonTitle={showHint ? "Project actions — click to restore" : "Project actions"}
          triggerClassName="btn subtle menu-btn"
          disabled={loading}
          renderTriggerChildren={() => (
            <>
              ⋮ {showHint && (
                  <span className="kebab-hint"></span>
              )}
            </>
          )}
        />

        <Modal isOpen={showDeleteModal} onClose={() => this.setState({ showDeleteModal: false })}>
          <div style={{ maxWidth: 420 }}>
            <h2 style={{ marginTop: 0 }}>Delete "{project.title}"?</h2>
            <p>This will permanently delete all chapters in this project.</p>
            <p>If you want to keep your work, copy the chapters into a new project first.</p>
            <p><strong>This cannot be undone.</strong></p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 24 }}>
              <button
                className="btn subtle"
                onClick={() => this.setState({ showDeleteModal: false })}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="btn danger"
                onClick={this.confirmDelete}
                disabled={loading}
              >
                {loading ? 'Deleting…' : 'Delete project'}
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

export default withRouter(ProjectActionsMenu);
